{
  "level": "bs0304mv",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:bs0304mv",
    "objects": "AREAS.E3:bs0304mv.e3",
    "mesh": "TREES.E3:bs0304mv.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 1.0,
      "bbox_min": [
        -10.0,
        -10.0,
        -1.0
      ],
      "bbox_max": [
        10.0,
        10.0,
        -1.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 1628,
      "centroid": [
        -3012.0,
        -3923.6031494140625,
        1060.123779296875
      ],
      "bbox_min": [
        -3026.0,
        -3925.124267578125,
        1052.623779296875
      ],
      "bbox_max": [
        -2998.0,
        -3922.08203125,
        1067.623779296875
      ],
      "dimensions_source": {
        "span_x": 28.0,
        "span_y": 3.042236328125,
        "height_z": 15.0,
        "door_width": 28.0,
        "door_depth": 3.042236328125,
        "leaf_depth": 3.042236328125,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.108,
          -0.9941,
          0.0
        ]
      },
      "vertices": [
        [
          -3026.0,
          -3925.124267578125,
          1052.623779296875
        ],
        [
          -3026.0,
          -3925.124267578125,
          1067.623779296875
        ],
        [
          -2998.0,
          -3922.08203125,
          1067.623779296875
        ],
        [
          -2998.0,
          -3922.08203125,
          1052.623779296875
        ]
      ],
      "plane_distance": -3575.304
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 2296,
      "centroid": [
        -3140.0,
        -3955.0,
        1089.0119018554688
      ],
      "bbox_min": [
        -3140.0,
        -3959.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3140.0,
        -3951.0,
        1095.4000244140625
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 8.0,
        "height_z": 12.7762451171875,
        "door_width": 8.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3140.0,
          -3951.0,
          1082.623779296875
        ],
        [
          -3140.0,
          -3959.0,
          1082.623779296875
        ],
        [
          -3140.0,
          -3951.0,
          1095.4000244140625
        ],
        [
          -3140.0,
          -3959.0,
          1095.4000244140625
        ]
      ],
      "plane_distance": 3140.0
    }
  ],
  "tutorial_messages": []
}